
// WorksiteNameColumn.jsx
import React, { useCallback } from "react";

const WorksiteNameColumn = ({ des_worksite, address, city, countryCode, id }) => {
  const hasAName =
    des_worksite.trim().toUpperCase() !== `${address}  - ${city}`.trim().toUpperCase();

  const url = `/${countryCode}/worksites/${id}`;

  const openInNewTabViaHiddenAnchor = useCallback(
    (href) => {
      const a = document.createElement("a");
      a.href = href;
      a.target = "_blank";
      a.rel = "noopener noreferrer"; // prevent access to window.opener
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    []
  );

  const handleActivate = useCallback(() => {
    openInNewTabViaHiddenAnchor(url);
  }, [openInNewTabViaHiddenAnchor, url]);

  const handleKeyDown = (e) => {
    // Make it accessible like a link/button
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleActivate();
    }
  };

  return (
    <div
      // Visuals
      className={id && countryCode ? "underline cursor-pointer": ""}
      // Accessibility
      role="link"
      tabIndex={0}
      aria-label={`Apri in una nuova scheda: ${hasAName ? des_worksite : address}`}
      // Behavior
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
    >
      <div>{hasAName ? des_worksite : address}</div>
      {hasAName && <div className="mt-1 text-xs">{address}</div>}
    </div>
  );
};

export default WorksiteNameColumn;
